export default {
  keys: {
    encryption:
      import.meta.env.PAGARME_ENCRYPTION_KEY ??
      import.meta.env.VITE_PAGARME_ENCRYPTION_KEY,
  },
}
